import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { noop, bindKey } from 'lodash'
import { Button, ListingCard, ListingCardViewModeEnum } from '@adc/ui-core'
import _cx from 'classnames/bind'
import cls from './styles.scss'
import { listingPropType } from '../listingCarousel'
const cx = _cx.bind(cls)

export default class ListingPhotoGrid extends Component {
  static propTypes = {
    listings: PropTypes.arrayOf(listingPropType),
    analytics: PropTypes.shape({
      save: PropTypes.func,
      click: PropTypes.func,
      hover: PropTypes.func,
    }),
    elmId: PropTypes.string,
    showMoreButtonLabel: PropTypes.string,
    showSave: PropTypes.bool,
    onSaveToggle: PropTypes.func,
    featureFlags: PropTypes.object,
    initialTotalListings: PropTypes.number,
  }

  static defaultProps = {
    save: noop,
    initialTotalListings: 8,
  }

  state = {
    showMorePhotos: false,
  }

  showMorePhotos = event => {
    event.preventDefault()
    this.setState({
      showMorePhotos: !this.state.showMorePhotos,
    })
  }

  render() {
    const {
      analytics,
      listings,
      elmId,
      showMoreButtonLabel,
      showSave,
      onSaveToggle,
      featureFlags,
      initialTotalListings,
    } = this.props
    const { showMorePhotos } = this.state
    const defaultAnalytics = {
      save: noop,
      click: noop,
      hover: noop,
    }
    const finalAnalytics = Object.assign({}, defaultAnalytics, analytics)
    const cards = showMorePhotos
      ? listings
      : listings.slice(0, initialTotalListings)
    const buttonLabel = showMoreButtonLabel || 'Show Me More'

    return (
      <div
        className={cx('photo-grid-container')}
        data-elm-id={`${elmId}_photo_grid`}
      >
        <div className={cx('grid')}>
          {cards.map((listing, i) => (
            <div key={i} className={cx('column')}>
              <ListingCard
                elmId={`${elmId}_listing_card_${i}`}
                listing={listing}
                showSave={showSave}
                onSaveToggle={onSaveToggle}
                viewMode={ListingCardViewModeEnum.GRID}
                linkProps={{
                  href: listing.listing_page_path,
                  onClick: bindKey(finalAnalytics, 'click', null, i),
                  onMouseLeave: bindKey(finalAnalytics, 'hover', null, i),
                }}
                featureFlags={featureFlags}
              />
            </div>
          ))}
        </div>
        {listings.length > initialTotalListings && !showMorePhotos ? (
          <div className={cx('grid-show-more')}>
            <Button
              className={cx('button-show-more')}
              elmId={`${elmId}_photo_grid_show_more`}
              size='medium'
              role='primary'
              onClick={this.showMorePhotos}
            >
              {buttonLabel}
            </Button>
          </div>
        ) : (
          <div className='u-mb-6' />
        )}
      </div>
    )
  }
}
